export default "__VITE_ASSET__7TK_WK43__"